import * as React from 'react';

import { TChatbotReaction } from '../../../../../types/chatbot';
import { IOfferMessage } from '../types';

interface IOfferExpertState {
  reaction: TChatbotReaction | undefined;
  isExpertEnabled: boolean | undefined;
}

export const useOfferExpertState = (offer: IOfferMessage | undefined): IOfferExpertState => {
  const [reaction, setReaction] = React.useState<TChatbotReaction | undefined>(undefined);
  const [isExpertEnabled, setIsExpertEnabled] = React.useState<boolean | undefined>(undefined);

  React.useEffect(() => {
    if (offer) {
      setReaction(offer?.reaction ?? undefined);
      setIsExpertEnabled(offer?.isExpertEnabled ?? undefined);
    } else {
      setReaction(undefined);
    }
  }, [offer]);

  return { reaction, isExpertEnabled };
};
